import { supabase } from './supabase';

/**
 * Reusable "who we are / what we do" identity blocks. Assigned to AI agents
 * (via config.business_profile_id) to ground them in the organization.
 */
export interface BusinessProfile {
  id: string;
  business_id: string;
  name: string;
  company_name: string | null;
  about: string | null;
  services_summary: string | null;
  service_area: string | null;
  differentiators: string | null;
  website: string | null;
  created_at: string;
  updated_at: string;
}

export interface BusinessProfileInput {
  name: string;
  company_name?: string;
  about?: string;
  services_summary?: string;
  service_area?: string;
  differentiators?: string;
  website?: string;
}

export async function listBusinessProfiles(businessId: string): Promise<BusinessProfile[]> {
  const { data, error } = await supabase
    .from('business_profiles')
    .select('*')
    .eq('business_id', businessId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data ?? []) as BusinessProfile[];
}

export async function getBusinessProfile(id: string): Promise<BusinessProfile | null> {
  const { data, error } = await supabase
    .from('business_profiles')
    .select('*')
    .eq('id', id)
    .maybeSingle();
  if (error) throw error;
  return (data as BusinessProfile) ?? null;
}

export async function createBusinessProfile(
  businessId: string,
  input: BusinessProfileInput,
): Promise<BusinessProfile> {
  const { data, error } = await supabase
    .from('business_profiles')
    .insert({
      business_id: businessId,
      name: input.name,
      company_name: input.company_name || null,
      about: input.about || null,
      services_summary: input.services_summary || null,
      service_area: input.service_area || null,
      differentiators: input.differentiators || null,
      website: input.website || null,
    })
    .select('*')
    .single();
  if (error) throw error;
  return data as BusinessProfile;
}
